import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import LeftScrollIcon from "../../../Custom-imeges/Workflows-Icons/leftScrollIcon";
import RightScrollIcon from "../../../Custom-imeges/Workflows-Icons/RightScrollIcon";
import { WorkflowAppsType, workflowItem } from "../../../Types/Workflow-Types";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { AIDetectorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/AIDetectorIcon";
import { TitleGeneratorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TitleGeneratorIcon";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import { GenerateImgIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { GenerateLogoIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateLogoIcon";
import { GenerateIconIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIconIcon";
import { GenerateIllsturationsIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIllsturationsIcon";
import { ImageRestoreIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageRestoreIcon";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import { BgRemoverIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/BgRemoverIcon";
import GreaterThanIcon from "../../../Custom-imeges/GreaterThanIcon";
import TextToVideoIcon from "../../../Custom-imeges/VideoSuite/TextToVideoIcon";
import ImageToVideoIcon from "../../../Custom-imeges/VideoSuite/ImageToVideoIcon";

interface WorkflowSelectedAppProps {
  workflowDetails: workflowItem[];
  setSelectedItemData: (Obj: workflowItem) => void;
  handleNewStep: () => void;
  selectedItemData: workflowItem;
}
const WorkflowSelectedSteps = ({
  workflowDetails,
  setSelectedItemData,
  handleNewStep,
  selectedItemData,
}: WorkflowSelectedAppProps) => {
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const { scrollWidth, clientWidth, scrollLeft } = containerRef.current;
        setIsScrollable(scrollWidth > clientWidth);
        setAtStart(scrollLeft === 0);
        setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1);
      }
    };
    checkScroll();
    if (containerRef.current) {
      containerRef.current.addEventListener("scroll", checkScroll);
    }

    window.addEventListener("resize", checkScroll);
    return () => {
      window.removeEventListener("resize", checkScroll);
      if (containerRef.current) {
        containerRef.current.removeEventListener("scroll", checkScroll);
      }
    };
  }, [workflowDetails]);

  const WorkflowAppsIcons: Partial<Record<WorkflowAppsType, JSX.Element>> = {
    [WorkflowAppsType.Translator]: <TranslatorIcon className="custom-icon" />,
    [WorkflowAppsType.Humanizer]: <HumanizeIcon className="custom-icon-stroke" />,
    [WorkflowAppsType.Summarizer]: <SummarizeIcon className="custom-icon" />,
    [WorkflowAppsType.Paraphraser]: <ParaphraseIcon className="custom-icon" />,
    [WorkflowAppsType.PromptGenerator]: <PromptEngineerIcon className="custom-icon" />,
    [WorkflowAppsType.TextToImage]: <GenerateImgIcon className="custom-icon" />,
    [WorkflowAppsType.LogoGenerator]: <GenerateLogoIcon className="custom-icon" />,
    [WorkflowAppsType.IconGenerator]: <GenerateIconIcon className="custom-icon" />,
    [WorkflowAppsType.IllustrationGenerator]: (
      <GenerateIllsturationsIcon className="custom-icon" />
    ),
    [WorkflowAppsType.ImageRestore]: <ImageRestoreIcon className="custom-icon" />,
    [WorkflowAppsType.TextExtraction]: <ImageTranscaptionIcon className="custom-icon" />,
    [WorkflowAppsType.BackgroundRemover]: <BgRemoverIcon className="custom-icon-stroke" />,
    [WorkflowAppsType.TextToVideo]: <TextToVideoIcon className="custom-icon" />,
    [WorkflowAppsType.ImageToVideo]: <ImageToVideoIcon className="custom-icon" />,
  };

  const WorkflowAppsIconsBlue: Partial<Record<WorkflowAppsType, JSX.Element>> = {
    [WorkflowAppsType.Translator]: <TranslatorIcon className="custom-icon-blue" />,
     [WorkflowAppsType.Humanizer]: <HumanizeIcon className="custom-icon-blue" />,
    [WorkflowAppsType.Summarizer]: <SummarizeIcon className="custom-icon-blue" />,
    [WorkflowAppsType.Paraphraser]: <ParaphraseIcon className="custom-icon-blue" />,
    [WorkflowAppsType.PromptGenerator]: <PromptEngineerIcon className="custom-icon-blue" />,
    [WorkflowAppsType.TextToImage]: <GenerateImgIcon className="custom-icon-blue" />,
    [WorkflowAppsType.LogoGenerator]: <GenerateLogoIcon className="custom-icon-blue" />,
    [WorkflowAppsType.IconGenerator]: <GenerateIconIcon className="custom-icon-blue" />,
    [WorkflowAppsType.IllustrationGenerator]: (
      <GenerateIllsturationsIcon className="custom-icon-blue" />
    ),
    [WorkflowAppsType.ImageRestore]: <ImageRestoreIcon className="custom-icon-blue" />,
    [WorkflowAppsType.TextExtraction]: <ImageTranscaptionIcon className="custom-icon-blue" />,
    [WorkflowAppsType.BackgroundRemover]: <BgRemoverIcon className="custom-icon-blue" />,
    [WorkflowAppsType.TextToVideo]: <TextToVideoIcon className="custom-icon-blue" />,
    [WorkflowAppsType.ImageToVideo]: <ImageToVideoIcon className="custom-icon-blue" />,
  };
  return (
    <Box className="text-suites-navbar position-relative create-workflow-navbar d-flex align-item-center justify-content-center mt-2 ">
      {isScrollable && !atStart && (
        <button
          className="scroll-left"
          onClick={() =>
            containerRef.current?.scrollBy({
              left: -100,
              behavior: "smooth",
            })
          }
        >
          <LeftScrollIcon className="custom-icon" />
        </button>
      )}
      <div className="workflow-nav-items-container" ref={containerRef}>
        {workflowDetails.length > 0 &&
          workflowDetails.map((app, i) => (
            <>
              <Box key={i} sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  className={`d-flex align-items-center position-relative app-create-workflow-item`}
                  style={{ textDecoration: "none !important" }}
                  onClick={() => setSelectedItemData(app)}
                >
                  <Box>
                    {selectedItemData.appOrder === app.appOrder ? (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "2px solid #12B6EA",
                          borderRadius: "50%",
                          padding: "5px 6px",
                        }}
                      >
                        { WorkflowAppsIconsBlue[app.appType as WorkflowAppsType] }
                      </span>
                    ) : (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "2px solid var(--A_font-color70)",
                          borderRadius: "50%",
                          padding: "5px 6px",
                        }}
                      >
                        { WorkflowAppsIcons[app.appType as WorkflowAppsType] }
                      </span>
                    )}
                  </Box>
                  <span
                    className={`app-create-workflow-item`}
                    style={{
                      textDecoration: "none !important",
                      color:
                        selectedItemData.appOrder === app.appOrder
                          ? "#12B6EA"
                          : "var(--A_font-color70)",
                    }}
                  >
                    {app.appType}
                  </span>
                </Box>
              </Box>
              <GreaterThanIcon className="custom-icon-stroke" />
            </>
          ))}

        <div className="position-relative">
          {!selectedItemData.appType ? (
            <Box
              className={`step-workflow`}
              style={{ textDecoration: "none !important" }}
            >
              Step
              {workflowDetails.length === 0 ? 1 : workflowDetails.length + 1}
            </Box>
          ) : (
            <Box
              className={`step-workflow position-relative`}
              style={{ textDecoration: "none !important" }}
              onClick={handleNewStep}
            >
              <span style={{ fontSize: "20px" }}>+</span>
              New step
            </Box>
          )}
        </div>
      </div>
      {/* Right Scroll Button */}
      {isScrollable && !atEnd && (
        <button
          className="scroll-right"
          onClick={() =>
            containerRef.current?.scrollBy({
              left: 100,
              behavior: "smooth",
            })
          }
        >
          <RightScrollIcon className="custom-icon" />
        </button>
      )}
    </Box>
  );
};

export default WorkflowSelectedSteps;
